<template>
  <v-container fluid pa-0>
    <div v-for="key in Object.keys(groupedRatesList)" :key="key">
      <h5 class="headline text-xs-left pb-3 pt-3">{{groupedRatesList[key].label}}</h5>
      <v-card>
        <v-list class="pa-0" two-line>
          <template v-for="(item,index) in groupedRatesList[key].items">
            <v-divider v-if="index !== 0" :key="`${item.id}-divider`"></v-divider>
            <v-list-item @click :key="`it-${item.id}`">
              <supplier-rates-edit-vlist-view-item
                :key="`${item.id}`"
                :item="item"
                :service-grouping="selectedGroupOption == 'byService'"
                :rate-types="rateTypes"
                @editItem="$emit('editItem',$event)"
                @deleteItem="$emit('deleteItem',$event)"
                @save="onSave"
              ></supplier-rates-edit-vlist-view-item>
            </v-list-item>
          </template>
        </v-list>
      </v-card>
    </div>
  </v-container>
</template>

<script>
import SupplierRatesEditVlistViewItem from "./SupplierRatesEditVlistViewItem";
import EventBus from "../../../../../store/event-bus";

export default {
  name: "SupplierRatesEditListVlistView",
  components: {
    SupplierRatesEditVlistViewItem
  },
  props: {
    supplierRatesList: {
      type: Array,
      default: () => []
    },
    rateTypes: {
      type: Array,
      default: () => {}
    },
    agentGroups: {
      type: Array,
      default: () => {}
    },
    selectedGroupOption: {
      type: String,
      default: ""
    },
    groupedRatesList: {
      type: Object
    }
  },
  methods: {
    // bySeason() {
    //   return this.supplierRatesList.reduce((group, item) => {
    //     group[item.dateFrom + item.dateTo] = group[
    //       item.dateFrom + item.dateTo
    //     ] || { label: "", items: [] };
    //     group[item.dateFrom + item.dateTo].label =
    //       "Season: (From: " +
    //       this.$options.filters.formatDate(item.dateFrom) +
    //       ", To: " +
    //       this.$options.filters.formatDate(item.dateTo) +
    //       ")";
    //     group[item.dateFrom + item.dateTo].items.push(item);
    //     return group;
    //   }, {});
    // },
    // byService() {
    //   return this.supplierRatesList.reduce((group, item) => {
    //     group[item.service.id] = group[item.service.id] || {
    //       label: "",
    //       items: []
    //     };
    //     group[item.service.id].label = item.service.name;
    //     group[item.service.id].items.push(item);
    //     return group;
    //   }, {});
    // },
    onSave() {
      this.$store.dispatch("showAppSnackbar", { msg: "Supplier Rate saved." });
      EventBus.$emit("refetch-supplier-rates");
    }
  },
  computed: {
    // groupedRatesList() {
    //   return this[this.selectedGroupOption]();
    // }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/gt/suppliers/supplier-rates/edit/SupplierRatesEditListVlistView.vue